module.exports = __webpack_public_path__ + "static/media/trunkrs-loader-icon.2686b775.svg";